import Page from "../../framework/Page";
import View from "../../framework/View";
import { Images } from "../../../Images";
import MinedUpgradeCollection from "../../../model/upgrade/free/MinedUpgradeCollection";
import FreeUpgrade from "../../../model/upgrade/free/FreeUpgrade";

export default class MinedUpgradeView extends View {
    /**
     * @param {string} parentId 
     * @param {string} elementId 
     * @param {MinedUpgradeCollection} minedUpgradeCollection
     */
    constructor(parentId, elementId, minedUpgradeCollection) {
        super(parentId, elementId);

        /**
         * @constant
         * @type {string}
         */
        this.titleDescriptionContainerId =  elementId + '_text';

        /**
         * @constant
         * @type {MinedUpgradeCollection}
         */
        this.minedUpgradeCollection = minedUpgradeCollection;

        /**
         * @type {FreeUpgrade}
         */
        this.upgrade = null;

        /**
         * @type {HTMLElement}
         */
        this.mainElement = null;

        /**
         * @type {HTMLElement}
         */
        this.titleDescriptionContainer = null;

        /**
         * @type {HTMLElement}
         */
        this.imgElement = null;

        /**
         * @type {HTMLElement}
         */
        this.titleElement = null;

        /**
         * @type {string}
         */
        this.displayedTitle = null;

        /**
         * @type {string}
         */
        this.displayedDescription = null;
        /**
         * @type {HTMLElement}
         */
        this.descriptionElement = null;

        /**
         * @type {string}
         */
        this.displayedIconFileName = null;

        /**
         * @type {boolean}
         */
        this.displayedPurchasable = true;  // The UI starts out in purchasable mode.
    }

    /**
     * @param {FreeUpgrade} upgrade 
     */
    setUpgrade(upgrade) {

        if (this.upgrade === upgrade) {
            return;
        }

        this.upgrade = upgrade;


        if (upgrade) {
            const description = this.upgrade.getDescription();
            this.displayedDescription = null; // clear the saved description

            if (!description) {
                // Clear out the description element.
                if (this.descriptionElement) {
                    Page.removeElement(this.titleDescriptionContainerId, this.descriptionElement);
                    this.descriptionElement = null;
                }

                // Make sure the title is set to the single line style
                this.titleElement.className = 'mined-upgrade-button-title-single-row';
            }
            else if (!this.descriptionElement) {
                // Create the description element.
                this.descriptionElement = Page.createElement('div', this.titleDescriptionContainer, null, 'mined-upgrade-button-description');
                this.descriptionElement.innerHTML = '';

                // Set the title to use the double line style
                this.titleElement.className = 'mined-upgrade-button-title-double-row';
            }

            // Initialize the 'displayedPurchasable' to be opposite of the actual value to force the
            // UI to be updated.
            this.displayedPurchasable = !this.upgrade.isPurchasable();                

            this.setViewVisible(true);
        }
        else {
            this.setViewVisible(false);
        }
    }

    /**
     * @override
     */
    initializeView() {
        // The upgrade view is dynamically created.
        const id = this.getElementId();

        const parent = Page.getElement(this.parentId);
        if (!parent) {
            console.log('UpgradeView.initializeView() No parent element found! parentId=' + this.parentId);
            return;
        }

        this.mainElement = Page.createElement('div', parent, id, 'upgrade-button-outer'); // <-- this is purchasable mode

        const bodyElement = Page.createElement('div', this.mainElement, null, 'mined-upgrade-button-body');


        const iconElement = Page.createElement('div', bodyElement, null, 'icon-container');

        // Title/Description container
        this.titleDescriptionContainer = Page.createElement('div', bodyElement, this.titleDescriptionContainerId, 'mined-upgrade-title-description-container');

        // <img src="images/miner_icon_51x48.png"/>
        this.imgElement = Page.createElement('img', iconElement, null, null);
        this.imgElement.src = Images.pick;

        // By default make the title use the 'single-row' style
        this.titleElement = Page.createElement('div', this.titleDescriptionContainer, null, 'mined-upgrade-button-title-single-row');
        this.titleElement.innerHTML = '';

        //////////////////////////////////////
        // Setup initial visibility
        //////////////////////////////////////

        // Initialize the upgrade button as not visible.
        Page.hideElement(this.mainElement);
        this.setViewVisible(false); // Let the super class know that the view is not currently visible.

        //////////////////////////////////////
        // Button Click
        //////////////////////////////////////

        const thisRef = this;
        this.mainElement.onclick = function() {
            if (!thisRef.upgrade || !thisRef.upgrade.isPurchasable()) {
                return;
            }

            if (thisRef.upgrade.purchase()) {
                // Our upgrades are removed when they are purchased.
                thisRef.minedUpgradeCollection.remove(thisRef.upgrade);
                thisRef.upgrade = null;
                thisRef.setViewVisible(false);
            }
        };

        super.initializeView();
    }

    /**
     * @override
     */
    updateViewContents() {
        if (!this.upgrade) {
            return;
        }

        const title = this.upgrade.title;
        if (title !== this.displayedTitle) {
            this.displayedTitle = title;
            this.titleElement.innerHTML = title;
        }

        const description = this.upgrade.getDescription();
        if (description && description !== this.displayedDescription) {
            this.displayedDescription = description;
            if (this.descriptionElement) {
                this.descriptionElement.innerHTML = description;
            }
            else {
                console.log('MinedUpgradeView.updateViewContents() null description element');
            }
        }

        const iconFileName = this.upgrade.iconFileName;
        if (this.displayedIconFileName !== iconFileName) {
            this.displayedIconFileName = iconFileName;
            this.imgElement.src = iconFileName;
        }

        const purchasable = this.upgrade.isPurchasable();
        if (this.displayedPurchasable !== purchasable) {
            this.displayedPurchasable = purchasable;

            if (purchasable) {
                this.mainElement.className = 'upgrade-button-outer';
            }
            else {
                this.mainElement.className = 'upgrade-button-outer-not-purchasable';
            }
        }
    }

}